const Logger = console;
const log = (action, result) => Logger.log(action, result);
export default function loggerMiddleWare({ getState }) {
  return (next) => (action) => {
    if (!window.LogActions) return next(action);
    try {
      const actionReturn = next(action);
      log(action, { afterState: getState() });
      return actionReturn;
    } catch (e) {
      log(action, { error: e });
      throw e;
    }
  };
}
